import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RecrutiationSource } from '../../app/Dto/RecrutationSource';

@Injectable()
export class RecruitmentSourceService {
  
  constructor(private http: HttpClient) {
 }
  private indeedRecruitmentSourceUrl = environment.settings.apiEndpoint + '/api/RecruitmentSources/SaveIndeedSource';

 
  saveIndeedSource(model: RecrutiationSource) {
    return this.http.post<RecrutiationSource[]>(
      this.indeedRecruitmentSourceUrl,
      model
    );
  }
 
}
